export default function (phone, message) {
  message = message.replace(/ /g, '%20').replace(/=/g, '%3D').replace(/&/g, '%26').replace(/\?/g, '%3F').replace(/\n/g, '%0A')
  const api = 'https://api.whatsapp.com'
  const url = `${api}/send?phone=55${phone}&text=${message}`

  window.location.href = url
}
